<!-- 工作台 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">联盟角色</div>
                <el-select
                    class="search-item"
                    size="small"
                    v-model="roleId"
                    remote
                    filterable
                    allow-create
                    placeholder="请输入角色名称"
                    :remote-method="querySearch"
                    v-select-scroll-more="searchRoleLoad"
                    @change="roleChange"
                >
                    <el-option v-for="item in roleOptions" :key="item.RoleId" :label="item.RoleName" :value="item.RoleId"> </el-option>
                </el-select>
                <div class="search-name">
                    <el-checkbox v-model="roleCheck">当角色改变时，同步联盟成员角色</el-checkbox>
                </div>
                <el-button size="small" class="search-btn btn-primary" @click="saveAuth" v-if="isShowSave">保存权限</el-button>
            </div>
        </div>
        <div class="permission-ctn">
            <div class="permission-tree">
                <el-tree
                    ref="tree"
                    :check-strictly="true"
                    :data="treeData"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    show-checkbox
                    node-key="Id"
                    default-expand-all
                    :default-checked-keys="checkedTree"
                    @check="handleNodeChecked"
                >
                    <div class="custom-tree-node" slot-scope="{ node, data }">
                        <span class="element-name" :class="{ lv3: node.level == 3 }">{{ data.Name }}</span>
                        <span class="element-ops">
                            <span v-for="item in data.Elements" :key="item.Id">
                                <input type="checkbox" v-bind:value="item.Id" v-model="selelementsId" @change="checkElem($event, item, node)" />
                                {{ item.Name }}
                            </span>
                        </span>
                    </div>
                </el-tree>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['memberId', 'mRoleId'],
    name: '',
    data() {
        return {
            unionId: this.$util.getLocalStorage('currentUnion'),
            loading: false,
            treeData: [], //模块树数据集
            checkedTree: [], //已选中的树节点
            selelementsId: [],
            parentsData: [],
            roleId: '',
            assignPermissions: [],
            roleCheck: true,
            defaultProps: {
                children: 'Children',
                label: 'Name'
            },
            roleForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            roleOptions: [],
            isShowSave: false
        };
    },
    mounted() {
        if (this.memberId) {
            this.getSelectedAuth();
            this.querySearch();
        }
        if (this.mRoleId) this.roleId = this.mRoleId;
    },
    methods: {
        getSelectedAuth() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetCheckedUnionMemberModulesIds',
                    data: {
                        MemberId: this.memberId,
                        UnionId: this.unionId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.checkedTree = res.data.selmodulesId;
                    this.selelementsId = res.data.selelementsId;

                    if (!this.treeData || this.treeData.length == 0) {
                        this.getPermission();
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 获取模块树接口
        getPermission() {
            this.$util
                .axiosGet({
                    url: '/api/Permission/GetEntpUnionModulesTree',
                    data: {
                        UnionId: this.unionId,
                        IsEdit: true
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.treeData = data;
                });
        },
        // 勾选模块
        handleNodeChecked(data, node) {
            this.assignPermissions = [];
            this.parentsData = [];
            let parentNode = this.$refs.tree.getNode(data.Id);
            if (parentNode) {
                this.getParentsNames(parentNode, []);
            }
            let _checkedTree = this.$refs.tree.getCheckedKeys();
            let flag = false;
            for (let i = 0; i < _checkedTree.length; i++) {
                if (_checkedTree[i] == data.Id) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                this.checkTreeNoHttp(data, true);
                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({
                            key: 'UserUnionModule',
                            secId: item.key
                        });
                    }
                });
                if (!this.isShowSave) this.AssignPermission();
            } else {
                this.checkTreeNoHttp(data, false);
                if (!this.isShowSave) this.UnAssignPermission();
            }
        },
        checkTreeNoHttp(node, checked) {
            this.$refs.tree.setChecked(node.Id, checked, 'deep');
            this.assignPermissions.push({ key: 'UserUnionModule', secId: node.Id });
            let that = this;
            //设置菜单下按钮是否选中
            node.Elements.forEach((x, index) => {
                that.assignPermissions.push({ key: 'UserUnionElement', secId: x.Id });
                if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                    that.selelementsId.push(x.Id);
                } else {
                    for (let i = 0; i < that.selelementsId.length; i++) {
                        if (that.selelementsId[i] == x.Id) {
                            that.selelementsId.splice(i, 1);
                            return true;
                        }
                    }
                }
            });
            //循环节点子级
            for (let i = 0; i < node.Children.length; i++) {
                that.$refs.tree.setChecked(node.Children[i].Id, checked, 'deep');
                that.assignPermissions.push({
                    key: 'UserUnionModule',
                    secId: node.Children[i].Id
                });
                //设置菜单下按钮是否选中
                node.Children[i].Elements.forEach((x, index) => {
                    that.assignPermissions.push({ key: 'UserUnionElement', secId: x.Id });
                    if (checked && that.selelementsId.indexOf(x.Id) == -1) {
                        that.selelementsId.push(x.Id);
                    } else {
                        for (let i = 0; i < that.selelementsId.length; i++) {
                            if (that.selelementsId[i] == x.Id) {
                                that.selelementsId.splice(i, 1);
                                return true;
                            }
                        }
                    }
                });
                //递归
                if (node.Children[i].Children[0]) {
                    that.checkTreeNoHttp(node.Children[i], checked);
                }
            }
        },
        //勾选权限操作按钮
        checkElem(event, data, node) {
            this.parentsData = [];
            this.getParentsNames(node, []);
            this.assignPermissions = [];
            this.assignPermissions.push({ key: 'UserUnionElement', secId: data.Id });
            if (event.target.checked) {
                if (this.selelementsId.indexOf(data.Id) == -1) {
                    this.selelementsId.push(data.Id);
                }

                this.parentsData.forEach(item => {
                    if (this.assignPermissions.findIndex(i => item.key === i.secId) === -1) {
                        this.$refs.tree.setChecked(item.key, true, false);
                        this.assignPermissions.push({
                            key: 'UserUnionModule',
                            secId: item.key
                        });
                    }
                });
                if (!this.isShowSave) this.AssignPermission();
            } else {
                let i = this.selelementsId.findIndex(item => {
                    if (item == data.Id) {
                        return true;
                    }
                });
                if (i > -1) {
                    this.selelementsId.splice(i, 1);
                }
                if (!this.isShowSave) this.UnAssignPermission();
            }
        },
        // 递归获取未选中父级列表
        getParentsNames(obj, result) {
            if (obj.key) {
                if (!obj.checked) {
                    result.push({
                        key: obj.key,
                        label: obj.label
                    });
                }
                this.getParentsNames(obj.parent, result);
            } else {
                this.parentsData = result;
            }
        },
        //分配权限
        AssignPermission() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/AssignUnionMemberPermission',
                    data: {
                        unionId: this.unionId,
                        firstId: this.memberId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.$util.successMsg('分配权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.assignPermissions = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 取消权限分配
        UnAssignPermission() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/Permission/UnAssignUnionMemberPermission',
                    data: {
                        unionId: this.unionId,
                        firstId: this.memberId,
                        permission: this.assignPermissions
                    }
                })
                .then(res => {
                    this.$util.successMsg('取消权限成功');
                    this.assignPermissions = [];
                })
                .catch(() => {
                    this.assignPermissions = [];
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 获取角色列表
        querySearch(key) {
            if (![undefined].includes(key)) {
                this.roleForm.Page = 1;
                this.roleForm.stopLoad = false;
                this.roleForm.key = key;
                this.roleOptions = [];
            }
            if (this.roleForm.stopLoad) return;
            this.$util.getUnionRoleList(this.roleForm.key, this.roleForm.Page, this.roleForm.Limit).then(data => {
                if (!data) return;
                this.roleForm.stopLoad = data.length < this.roleForm.Limit;
                this.roleOptions = this.$util.uniqueArr(this.roleOptions, data);
            });
        },
        searchRoleLoad() {
            this.roleForm.Page += 1;
            this.querySearch();
        },
        roleChange(value) {
            let that = this;
            if (value) {
                that.$util
                    .axiosGet({
                        url: '/api/Permission/GetCheckedUnionRoleModulesIds',
                        data: {
                            RoleId: value,
                            UnionId: that.unionId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        that.checkedTree = res.data.selmodulesId;
                        that.selelementsId = res.data.selelementsId;
                        that.treeData = [];
                        that.getPermission();
                        that.isShowSave = true;
                    })
                    .finally(() => {
                        that.loading = false;
                    });
            }
        },
        saveAuth() {
            let that = this;
            that.assignPermissions = [];
            that.parentsData = [];
            let _checkedTree = that.$refs.tree.getCheckedKeys();

            for (let i = 0; i < _checkedTree.length; i++) {
                that.assignPermissions.push({
                    key: 'UserUnionModule',
                    secId: _checkedTree[i]
                });
            }

            that.selelementsId.forEach((x, index) => {
                that.assignPermissions.push({ key: 'UserUnionElement', secId: x });
            });

            that.$util
                .axiosPost({
                    url: '/api/EntpUnions/SubmitMemberAuthData',
                    data: {
                        updateRole: this.roleCheck,
                        roleId: this.roleId,
                        memberId: that.memberId,
                        permission: that.assignPermissions
                    }
                })
                .then(res => {
                    that.$util.successMsg('保存权限成功');
                    that.assignPermissions = [];
                })
                .catch(() => {
                    that.assignPermissions = [];
                })
                .finally(() => {
                    that.loading = false;
                });
        }
    }
};
</script>
<style lang="less" scoped>
.permission-ctn {
    display: flex;
    width: 100%;
    height: 460px;
    padding-bottom: 50px;
    overflow-y: scroll;
}
</style>
<style lang="less">
.element-name {
    display: inline-block;
    width: 150px;
}
.el-tree-node {
    position: relative;
}
</style>
